<div class="options modal-main mt-3 !pl-0 !pt-0">
  <span class="field-label" i18n>Cumulated tags (existing tags on single or multiple but not all assets)</span>
  <!-- tags list in chip form -->
  <mat-chip-listbox>
    <mat-chip [removable]="true" class="mat-chipss" *ngFor="let tags of tagsObs; let i = index">
      <ng-container *ngIf="editingTag === tags._id; else notCurrentTag">
        <span *ngIf="!toggleEditTag">{{ tags.name }}</span>
        <div *ngIf="toggleEditTag" class="form-field-wrapper" (keydown.enter)="saveTagName(tags._id, i)" (keydown.escape)="exitRenameTag()">
          <input
            #renameInput
            matInput
            type="text"
            [(ngModel)]="tagName"
            (click)="$event.stopImmediatePropagation()"
            (keydown.arrowleft)="$event.stopImmediatePropagation()"
            (keydown.arrowright)="$event.stopImmediatePropagation()"
            (keydown.backspace)="$event.stopPropagation()"
            (keydown.delete)="$event.stopPropagation()"
          />
          <div class="form-field-actions">
            <button
              *ngIf="tagName"
              matSuffix
              mat-icon-button
              class="save-button icon-button-slim"
              aria-label="Save"
              i18n-matTooltip
              matTooltip="Save tag"
              (click)="saveTagName(tags._id, i); $event.stopImmediatePropagation()"
            >
              <mat-icon class="material-icons-outlined">save</mat-icon>
            </button>
            <button matSuffix mat-icon-button aria-label="Clear" class="icon-button-slim" i18n-matTooltip matTooltip="Close edit tag" (click)="exitRenameTag(); $event.stopImmediatePropagation()">
              <mat-icon class="material-icons-outlined">close</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>
      <ng-template #notCurrentTag>
        <span>{{ tags.name }}</span>
      </ng-template>
      <button matChipRemove #menuButton mat-icon-button i18n-matTooltip matTooltip="Tag options" class="menu-button icon-button-slim" [matMenuTriggerFor]="menu">
        <mat-icon class="material-icons-outlined">more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu" class="my-menu">
        <button mat-menu-item (click)="addTagToAllAssets(i)">
          <mat-icon class="material-icons-outlined">add</mat-icon>
          <span i18n>Use this tag for all selected assets</span>
        </button>
        <button mat-menu-item (click)="removeTagFromAllAssets(i)">
          <mat-icon class="material-icons-outlined">close</mat-icon>
          <span i18n>Remove this tag for all selected assets</span>
        </button>
        <button mat-menu-item (click)="renameTag(i)" [disabled]="toggleEditTag">
          <mat-icon class="material-icons-outlined">edit</mat-icon>
          <span i18n>Edit</span>
        </button>
      </mat-menu>
    </mat-chip>
  </mat-chip-listbox>
  <!-- Divider between search tags and tags list -->
  <mat-divider class="!mt-4"></mat-divider>
</div>
